import {Action} from '@ngrx/store';
import * as _ from 'lodash';
import {Country} from '../models/country';
import {countriesActionTypes, LoadCountriesSuccessAction} from '../actions/countries';

export interface CountriesState {
  array: Country[];
}

const initialState: CountriesState = {
  array: []
};

export function countriesReducer(state: CountriesState = initialState, action: Action): CountriesState {
  switch (action.type) {
    case countriesActionTypes.LOAD_SUCCESS:
      return handleLoadSuccessAction(state, action);
    default:
      return state;
  }
}

function handleLoadSuccessAction(state: CountriesState, action: LoadCountriesSuccessAction): CountriesState {
  const newState = _.clone(state);
  newState.array = action.payload;
  return newState;
}

export const countriesSelectors = {
  array: (state: CountriesState) => _.get(state, 'array', [])
};
